import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { colors, typography } = capitalDesignTokens.foundations;
const { interaction } = capitalDesignTokens.semanticColors;

// Helper for the drag-handle stipple — two stacked linear gradients produce a
// dotted-grid look. Parameterised so we can shift it to a darker color on hover.
const stippleGradient = (dotColor: string, bgColor: string) =>
  `linear-gradient(to bottom, transparent 50%, ${bgColor} 50%), ` +
  `linear-gradient(to right, ${dotColor} 50%, ${bgColor} 50%)`;

export const styles = createTypedSxStyles({
  container: {
    backgroundColor: colors.gray200
  },
  activeContainer: {
    backgroundColor: colors.gray300
  },
  paddingContainer: {
    padding: '4px'
  },
  dragHandle: {
    backgroundImage: stippleGradient(colors.gray300, colors.white),
    backgroundSize: '6px 6px, 6px 6px',
    height: '100%',
    width: '12px'
  },
  card: {
    alignItems: 'stretch',
    backgroundColor: colors.white,
    border: `1px solid ${colors.gray300}`,
    borderRadius: '4px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.16)',
    display: 'flex',
    fontFamily: typography.baseFont,
    fontSize: typography.fontSize.bodyDefault,
    lineHeight: typography.lineHeight.bodyDefault,
    padding: '16px 8px',
    '&:hover': {
      backgroundColor: colors.white,
      border: `1px solid ${colors.gray700}`,
      '& .ReorderableBlockListItem-dragHandle': {
        backgroundImage: stippleGradient(colors.gray500, colors.white)
      }
    },
    '&:focus-visible': {
      outline: `2px solid ${interaction.focus}`,
      outlineOffset: '2px'
    }
  },
  cardSelected: {
    backgroundColor: interaction.hoverLight,
    border: `1px solid ${interaction.selectionHeavy}`,
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.08)',
    '& .ReorderableBlockListItem-dragHandle': {
      backgroundImage: stippleGradient(interaction.selectionHeavy, interaction.hoverLight)
    },
    '&:hover': {
      backgroundColor: interaction.hoverLight,
      '& .ReorderableBlockListItem-dragHandle': {
        backgroundImage: stippleGradient(interaction.selectionHeavy, interaction.hoverLight)
      }
    }
  },
  cardDragging: {
    backgroundColor: interaction.hoverLight,
    border: `1px solid ${interaction.selectionHeavy}`,
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.08)',
    '& .ReorderableBlockListItem-dragHandle': {
      backgroundImage: stippleGradient(interaction.selectionHeavy, interaction.hoverLight)
    }
  },
  cardContent: {
    flex: 1,
    overflow: 'wrap',
    paddingRight: '8px'
  }
});
